import { render, staticRenderFns } from "./staffAppAuthManageList.vue?vue&type=template&id=9e5636ae&scoped=true"
import script from "./staffAppAuthManageList.vue?vue&type=script&lang=js"
export * from "./staffAppAuthManageList.vue?vue&type=script&lang=js"
import style0 from "./staffAppAuthManageList.vue?vue&type=style&index=0&id=9e5636ae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9e5636ae",
  null
  
)

export default component.exports